import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.self-pickups')
  .factory('selfPickupsAPI', SelfPickupsAPI);

function SelfPickupsAPI(): BringozApi {
  return {
    base: `/selfpickup`,
    infiniteScroll: {
      address: `/selfpickup`,
      cmd: 'GET'
    },
    actions: {
      createOne: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateOne: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      deleteOne: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
      sendMessage: {
        address: '{id}/message',
        cmd: 'POST',
        updateable: true
      },
      getTotals: {
        address: 'totals/statuses',
        cmd: 'GET',
        updateable: true
      },
      getTimelineLog: {
        address: '{id}/timeline',
        cmd: 'GET',
        updateable: false
      }
    }
  }
}
